import { CCol } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarCol = (props) => {
  const { children } = props
  return <CCol {...props}>{children}</CCol>
}

export { ConfiaCarCol }
